import { CompanyCategoryEnum } from "./company-category"

export class RmCountPriceListRequest{
    id:number
    minValue:number
    maxValue:number
    count:number
    price:number
    createduser:string
    updateuser:string
    company:string
    category?:CompanyCategoryEnum
    constructor(
        id:number,
        minValue:number,
        maxValue:number,
        count:number,
        price:number,
        createduser:string,
        updateuser:string,
        company:string,
    category?:CompanyCategoryEnum
    ){
        this.id=id
        this.minValue=minValue
        this.maxValue=maxValue
        this.count=count
        this.createduser=createduser
        this.price=price
        this.updateuser=updateuser
        this.category = category
        this.company = company
    }
}